import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationRocket = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationRocket',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_5601_1614)",
    d: "M13.292 74.04c3.336-3.335 8.709-3.372 12-.08 3.291 3.29 3.255 8.663-.082 12-4.195 4.195-11.564 1.3-15.147 5.436-.61-8.33 5.34-9.203 4.355-11.418-.985-2.216-3.143.324-4.094 1.275.26-2.733.988-5.232 2.968-7.212Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_5601_1614)",
    d: "M25.277 73.945c1.776 1.775 1.757 4.673-.042 6.472-2.261 2.261-5.69 1.483-8.445 2.492-.272-1.634 2.804-3.44 2.452-4.913-.353-1.474-1.389-1.549-2.225-1.665 2.049-3.875 6.152-4.494 8.26-2.386Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_5601_1614)",
    d: "M91.943 8.073c3.535 3.536-5.657 28.284-19.446 42.073C58.71 63.935 43.152 76.662 38.91 79.491c-4.243 2.828-8.132 1.768-9.9 0l-8.485-8.485c-1.414-1.415-2.829-5.657 0-9.9C23.353 56.864 36.08 41.307 49.87 27.52 63.658 13.73 88.407 4.538 91.943 8.073Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#2BB8F8",
    d: "M86.737 29.557c-3.56 7.215-8.502 14.851-14.24 20.589C58.71 63.935 43.152 76.662 38.91 79.491c-4.243 2.828-8.132 1.768-9.9 0l-5.515-5.515C37.33 69.234 51.165 61.673 65 50 75.7 40.973 83.044 33.51 86.737 29.557Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_5601_1614)",
    d: "M75.68 52.62c1.374 1.376-3.73 13.629-10.78 20.68-7.051 7.05-13.263 12.555-17.505 14.676-4.243 2.122-11.314-7.07-11.314-7.07s13.99-9.748 21.04-16.799c7.051-7.05 17.183-12.861 18.558-11.486Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#417BF2",
    d: "M36.081 80.905c.037-.026 12.34-8.6 19.672-15.475-3.24 4.612-7.14 10.675-8.253 14.57-.894 3.128.11 5.457 1.493 7.077-.56.346-1.093.646-1.598.899-4.238 2.119-11.297-7.049-11.314-7.071Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint4_linear_5601_1614)",
    d: "M47.395 24.337c-1.375-1.375-13.628 3.728-20.679 10.779-7.05 7.051-12.555 13.262-14.676 17.505-2.122 4.242 7.07 11.314 7.07 11.314s9.748-13.99 16.798-21.04C42.96 35.842 48.77 25.71 47.395 24.336Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#417BF2",
    d: "M19.11 63.935c.02-.028 9.754-13.997 16.798-21.04a58.17 58.17 0 0 0 4.163-4.666c-6.908 7.025-17.936 17.087-23.146 15.625-2.05-.575-3.536-1.178-4.612-1.756-.097.177-.188.352-.273.523-2.12 4.238 7.053 11.3 7.07 11.314Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint5_linear_5601_1614)",
    d: "M64.365 35.65a7 7 0 1 0 9.9-9.9 7 7 0 0 0-9.9 9.9Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FFD926",
    fillRule: "evenodd",
    d: "m81.833 93.85-.649-5.764a7.111 7.111 0 0 0-6.27-6.27l-5.764-.649c-.2-.02-.2-.315 0-.334l5.764-.649a7.111 7.111 0 0 0 6.27-6.27l.649-5.764c.02-.2.315-.2.334 0l.649 5.764a7.111 7.111 0 0 0 6.27 6.27l5.764.649c.2.02.2.315 0 .334l-5.764.649a7.111 7.111 0 0 0-6.27 6.27l-.649 5.764c-.029.2-.315.2-.334 0ZM28.872 22.884l-.5-4.433a5.47 5.47 0 0 0-4.823-4.823l-4.433-.5c-.154-.014-.154-.242 0-.257l4.433-.499a5.47 5.47 0 0 0 4.823-4.823l.5-4.433c.014-.155.242-.155.256 0l.5 4.433a5.47 5.47 0 0 0 4.822 4.823l4.434.5c.154.014.154.242 0 .257l-4.434.499a5.47 5.47 0 0 0-4.822 4.823l-.5 4.433c-.022.154-.242.154-.256 0Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_5601_1614",
    x1: 7.99,
    x2: 18.375,
    y1: 95.679,
    y2: 70.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.206,
    stopColor: "#FFE2B9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.223,
    stopColor: "#FFDFB6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.477,
    stopColor: "#FFB684"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.701,
    stopColor: "#FF9961"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.883,
    stopColor: "#FF874B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FF8043"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_5601_1614",
    x1: 16.241,
    x2: 24.724,
    y1: 83.726,
    y2: 72.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FEF7B5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.012,
    stopColor: "#FEF6B2"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.274,
    stopColor: "#FEDD73"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.512,
    stopColor: "#FFC942"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.72,
    stopColor: "#FFBB1E"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.889,
    stopColor: "#FFB208"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.998,
    stopColor: "#FFAF00"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_5601_1614",
    x1: 27.5,
    x2: 133.979,
    y1: 91,
    y2: 84.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.243,
    stopColor: "#4BC7FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#DEFBA9"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_5601_1614",
    x1: 84.791,
    x2: 65.404,
    y1: 54.763,
    y2: 41.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#C1D0C9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.516,
    stopColor: "#5E97F7"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4B8AFF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint4_linear_5601_1614",
    x1: 45.253,
    x2: 58.797,
    y1: 15.225,
    y2: 34.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#C1D0C9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.516,
    stopColor: "#5E97F7"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4B8AFF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint5_linear_5601_1614",
    x1: 75.5,
    x2: 66.262,
    y1: 27.5,
    y2: 37.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#6071EC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#3D404D"
  }))));
};
ColoredIllustrationRocket.displayName = 'ColoredIllustrationRocket';
export default withProvisionalOverrideFromContext(ColoredIllustrationRocket);
//# sourceMappingURL=index.js.map